import { useSelector } from "react-redux";
import * as _ from "lodash";

import { Enterprise, DataDescriptorEntity, EnterpriseAppState } from "@ctra/api";
import { UnitSystem } from "@ctra/utils";
import { useLocalization } from "@base";

/**
 * Get the unit for the data descriptor based on the currently selected unit system
 * optionally specify a unit system
 * @param dataDescriptorID
 * @param unitSystem
 */
export const useUnit = (
  dataDescriptorID: DataDescriptorEntity["id"],
  defaultUnitSystem?: UnitSystem
): string => {
  const { unitSystem } = useLocalization();
  /**
   * Resolve data descriptor from data descriptor id
   */
  const dataDescriptor = useSelector<EnterpriseAppState, DataDescriptorEntity>((state) =>
    Enterprise.entities.getDataDescriptor(state, { id: dataDescriptorID })
  );

  if (!dataDescriptor) {
    throw new Error(`Data descriptor "${dataDescriptorID}" could not be located in the store.`);
  }

  /**
   * Get the value based on currently selected system
   * or specified unit system
   * or a fallback default unit of metric
   */
  const unit = _.defaultTo(
    _.get(dataDescriptor, ["valueProperties", "units", defaultUnitSystem || unitSystem]),
    _.get(dataDescriptor, ["valueProperties", "units", UnitSystem.metric])
  ) as string;

  return unit;
};
